import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { ScriptLoaderService } from '../_services/script-loader.service'
import { Helpers } from '../helpers'
import {
  AlertService,
  AuthenticationService,
  UserService
} from '../theme/shared'
import { AlertComponent } from './_directives/alert.component'
import { LoginCustom } from './_helpers/login-custom'

@Component({
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './templates/login-4.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {
  public model: any = {}
  public loading = false
  public returnUrl: string

  @ViewChild('alertSignin', { read: ViewContainerRef })
  public alertSignin: ViewContainerRef
  @ViewChild('alertSignup', { read: ViewContainerRef })
  public alertSignup: ViewContainerRef
  @ViewChild('alertForgotPass', { read: ViewContainerRef })
  public alertForgotPass: ViewContainerRef

  constructor(
    private _router: Router,
    private _script: ScriptLoaderService,
    private _userService: UserService,
    private _route: ActivatedRoute,
    private _authService: AuthenticationService,
    private _alertService: AlertService,
    private cfr: ComponentFactoryResolver
  ) { }

  public ngOnInit() {
    this.model.remember = true
    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams.returnUrl || '/'
    this._router.navigate([this.returnUrl])

    this._script
      .load(
        'body',
        'assets/vendors/base/vendors.bundle.js',
        'assets/demo/default/base/scripts.bundle.js'
      )
      .then(() => {
        Helpers.setLoading(false)
        LoginCustom.init()
      })
      .catch()
  }

  public signin() {
    this.loading = true
    this._authService
      .login(this.model.username, this.model.password, this.model.remember)
      .subscribe(
        (data) => {
          if (data && data.access_token) {
            this._authService.saveUser(data)
          }
          this._router.navigate([this.returnUrl])
        },
        (error) => {
          // this.showAlert('alertSignin')
          this._alertService.error(error.errorMessage);
          this.loading = false
        }
      )
  }

  public signup() {
    this.loading = true
    this._userService.create(this.model).subscribe(
      (data) => {
        this.showAlert('alertSignin')
        this._alertService.success(
          'Thank you. To complete your registration please check your email.',
          true
        )
        this.loading = false
        LoginCustom.displaySignInForm()
        this.model = {}
      },
      (error) => {
        this.showAlert('alertSignup')
        this._alertService.error(error)
        this.loading = false
      }
    )
  }

  public forgotPass() {
    this.loading = true
    this._userService.forgotPassword(this.model.email).subscribe(
      (data) => {
        this.showAlert('alertSignin')
        this._alertService.success(
          'Cool! Password recovery instruction has been sent to your email.',
          true
        )
        this.loading = false
        LoginCustom.displaySignInForm()
        this.model = {}
      },
      (error) => {
        this.showAlert('alertForgotPass')
        this._alertService.error(error)
        this.loading = false
      }
    )
  }

  public showAlert(target) {
    this[target].clear()
    const factory = this.cfr.resolveComponentFactory(AlertComponent)
    const ref = this[target].createComponent(factory)
    ref.changeDetectorRef.detectChanges()
  }
}
